const c = {
  "cdr-icon": "cdr-icon_15-5-1",
  "cdr-icon--small": "cdr-icon--small_15-5-1",
  "cdr-icon--large": "cdr-icon--large_15-5-1",
  "cdr-icon--small@xs": "cdr-icon--small@xs_15-5-1",
  "cdr-icon--large@xs": "cdr-icon--large@xs_15-5-1",
  "cdr-icon--small@sm": "cdr-icon--small@sm_15-5-1",
  "cdr-icon--large@sm": "cdr-icon--large@sm_15-5-1",
  "cdr-icon--small@md": "cdr-icon--small@md_15-5-1",
  "cdr-icon--large@md": "cdr-icon--large@md_15-5-1",
  "cdr-icon--small@lg": "cdr-icon--small@lg_15-5-1",
  "cdr-icon--large@lg": "cdr-icon--large@lg_15-5-1",
  "cdr-icon--inherit-color": "cdr-icon--inherit-color_15-5-1",
  "cdr-accordion-group": "cdr-accordion-group_15-5-1",
  "cdr-accordion": "cdr-accordion_15-5-1",
  "cdr-accordion__button": "cdr-accordion__button_15-5-1",
  "cdr-accordion__label": "cdr-accordion__label_15-5-1",
  "cdr-accordion__header": "cdr-accordion__header_15-5-1",
  "cdr-accordion__header--unwrapped": "cdr-accordion__header--unwrapped_15-5-1",
  "cdr-accordion__icon": "cdr-accordion__icon_15-5-1",
  "cdr-accordion--open": "cdr-accordion--open_15-5-1",
  "cdr-accordion__content-container": "cdr-accordion__content-container_15-5-1",
  "cdr-tabs--open": "cdr-tabs--open_15-5-1",
  "cdr-accordion__content": "cdr-accordion__content_15-5-1",
  "cdr-accordion--closed": "cdr-accordion--closed_15-5-1",
  "cdr-accordion--unwrap": "cdr-accordion--unwrap_15-5-1",
  "cdr-accordion--border-aligned": "cdr-accordion--border-aligned_15-5-1",
  "cdr-accordion--no-spacing": "cdr-accordion--no-spacing_15-5-1",
  "cdr-accordion--compact": "cdr-accordion--compact_15-5-1",
  "cdr-accordion--focused": "cdr-accordion--focused_15-5-1"
};
export {
  c as default
};
